module.exports = __webpack_public_path__ + "img/2012-12-14 20.07.26.a76b314f.jpg";